import { useState } from "react";
import { useRootDispatch, useRootSelector } from "../../../store/hooks";
import { clearNotification } from "../../../store/notification/notification-slice";

import { NotificationMsg } from "./notificationMsg/NotificationMsg";
import classes from "./Notifications.module.scss";

export const BannerNotifications = () => {
  const { notifications } = useRootSelector((state) => state.notification);
  const [isDismissing, setIsDissmissing] = useState(false);
  const dispatch = useRootDispatch();

  const dismissibleNotification = notifications.find(
    (n) => !n.slideout && n.closable
  );

  const nonDismissibleNotifications = notifications.filter(
    (n) => !n.slideout && !n.closable
  );

  const handleDismiss = (id: string) => {
    setIsDissmissing(true);
    setTimeout(() => {
      dispatch(clearNotification(id));
      setIsDissmissing(false);
    }, 300);
  };

  if (!notifications.length) return null;

  return (
    <div className={classes.wrapper}>
      {nonDismissibleNotifications.map((notification) => (
        <div key={notification.id} className={classes.container}>
          <div className={classes.message}>
            <NotificationMsg
              type={notification.type}
              messages={notification.messages}
              translatedMessages={notification.translatedMessages}
              isClosable={false}
              isSlideoutBanner={false}
              onClose={() => {}}
            />
          </div>
        </div>
      ))}
      {dismissibleNotification && !isDismissing && (
        <div className={classes.container}>
          <NotificationMsg
            isClosable={true}
            type={dismissibleNotification.type}
            messages={dismissibleNotification.messages}
            translatedMessages={dismissibleNotification.translatedMessages}
            isDismissing={isDismissing}
            isSlideoutBanner={false}
            onClose={() => handleDismiss(dismissibleNotification.id)}
          />
        </div>
      )}
    </div>
  );
};
